import Skeleton from 'react-loading-skeleton'

import styled from 'styled-components'

import Box from '@ilg-totallymoney/ui/components/Box'
import Grid from '@ilg-totallymoney/ui/components/Grid'
import theme from '@ilg-totallymoney/ui/theme'

import * as Layout from '../UnscoredCard/components/UnscoredCardLayout'

const SkeletonBack = styled(Skeleton)`
    border-radius: ${theme.radii.borderRadius10};
    width: 125px;
    height: 19px;
`

const SkeletonHeading = styled(Skeleton)`
    border-radius: ${theme.radii.borderRadius10};
    width: 250px;
    height: 28px;

    ${theme.mediaMediumPlus`
        width: 375px;
    `}
`

const SkeletonImage = styled(Skeleton)`
    border-radius: ${theme.radii.borderRadius10};
    width: 216px;
    height: 137px;

    ${theme.mediaMediumPlus`
        width: 245px;
        height: 156px;
    `}
`

const SkeletonContent = styled.div`
    > span {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: ${theme.space20};
        margin-top: ${theme.space10};
    }
`

const SkeletonContentItem = styled(Skeleton)`
    display: inline-block;
    border-radius: ${theme.radii.borderRadius10};
    width: 100%;

    ${theme.mediaMediumPlus`
        width: 350px;
        height: 18px;
    `}
`

const SkeletonButton = styled(Skeleton)`
    margin-bottom: ${theme.space10};
    height: 48px;
    border-radius: ${theme.radii.borderRadius30};
    width: 252px;
`

const SkeletonProductList = () => {
    return (
        <Box>
            <Box mb="space20">
                <Skeleton
                    height={32}
                    width={158}
                    borderRadius={theme.radii.borderRadius10}
                />
            </Box>
            <Box>
                <Skeleton count={4} borderRadius={theme.radii.borderRadius10} />
            </Box>
        </Box>
    )
}

const UnscoredCardSkeleton = () => {
    return (
        <Grid>
            <Layout.BackLink>
                <SkeletonBack />
            </Layout.BackLink>
            <Layout.PageHeading>
                <SkeletonHeading />
            </Layout.PageHeading>
            <Layout.ItemWrapper>
                <Layout.ItemDetails>
                    <Layout.ItemImage>
                        <SkeletonImage />
                    </Layout.ItemImage>
                    <Layout.ItemContent>
                        <SkeletonContent>
                            <SkeletonContentItem count={4} inline={true} />
                        </SkeletonContent>
                    </Layout.ItemContent>
                </Layout.ItemDetails>
                <Layout.ItemButtons>
                    <SkeletonButton />
                </Layout.ItemButtons>
            </Layout.ItemWrapper>
            <Box gridColumn="1/13" pb="space50">
                <Box
                    display="grid"
                    gridTemplateColumns={['1fr', '1fr 1fr']}
                    gridGap={['space30', 'space50']}
                >
                    <SkeletonProductList />
                    <SkeletonProductList />
                    <SkeletonProductList />
                    <SkeletonProductList />
                </Box>
            </Box>
        </Grid>
    )
}

export default UnscoredCardSkeleton
